export default {
  title: 'Raport MRR',
  fields: {
    name: 'Nume',
    area: 'Zonă',
    mrr: 'MRR (net)',
  },
  buttons: {
    download_report: 'Descarcă raport',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor, vă rugăm reîncărcați pagina',
  },
};
